import Firebase from "firebaseInitializer";
import cn from "classnames";
import PopupNotifications from "components/popupNotifications";
import Loader from "components/shared/loader";
import OnlineChecker from "components/shared/onlineChecker";
import { TooltipFMEContainer } from "components/shared/tooltipFME";
import TransitionSwitch from "components/shared/transitionSwitch";
import BgTasks from "containers/bgTasks";
import LeafletMap from "containers/map";
import Modal from "containers/modal";
import { UnreadItemsProvider } from "contexts/unreadItemsContext";
import { featureModuleTypesEnum } from "helpers/enums";
import { isRegionDryingPeriodsEnabledForClients } from "helpers/regionDryingPeriods";
import { noRolesOtherThan } from "helpers/roles";
import React, { useEffect, useRef } from "react";
import RegionDryingPeriodsManager from "services/regionDryingPeriodsManager";
import Footer from "./footer";
import Header from "./header";
import Sidebar from "./sidebar";

export default function Layout(props) {
    const dryingPeriodsManagerRef = useRef(null);

    useEffect(() => {
        const {
            getInitial,
            getDictionaries,
            loadConfigs,
            getPlatonPoints,
            getPostamatPoints,
            getPaymentPoints,
            roles,
            profile,
            getRoadRestrictions,
            getRoadRestrictionTypes,
            setRegionDryingPeriods,
        } = props;

        let isMounted = true;

        getInitial().then(() => {
            if (!isMounted) {
                return;
            }

            // eslint-disable-next-line no-new
            new Firebase();
            if (isRegionDryingPeriodsEnabledForClients) {
                dryingPeriodsManagerRef.current = new RegionDryingPeriodsManager(setRegionDryingPeriods);
            }
            const reqs = noRolesOtherThan(roles, [
                "isGuest",
                "isTechSupport",
                "isAccountManager",
                "isDiagnostics",
                "isIntegrationManager",
            ])
                ? [getDictionaries(), loadConfigs()]
                : [
                      getDictionaries(),
                      loadConfigs(),
                      getPlatonPoints(),
                      getPaymentPoints(),
                      getRoadRestrictions(),
                      getRoadRestrictionTypes(),
                  ];

            if (profile.availableFeatureModules.includes(featureModuleTypesEnum.DocumentAssignment)) {
                reqs.push(getPostamatPoints());
            }

            return Promise.all(reqs);
        });

        return () => {
            isMounted = false;
            if (dryingPeriodsManagerRef.current) {
                dryingPeriodsManagerRef.current.disconnect();
            }
        };
    }, []);

    const { location, fullscreen, isMapAboveContent, children, isLoading, initialProfileLoaded } = props;
    if (!initialProfileLoaded) {
        return null;
    }

    const cName = cn({
        "page-layout": true,
        "page-layout--fullscreen": fullscreen,
        "page-layout--map": isMapAboveContent,
    });

    if (isLoading) {
        return (
            <div className="page-loader-wrap">
                <Loader />
            </div>
        );
    }
    return (
        <>
            <OnlineChecker />
            <UnreadItemsProvider>
                <div className={cName}>
                    <Header />
                    <Sidebar />
                    <main className="page-layout__content-wrap">
                        <TransitionSwitch location={location} name={location.pathname.split("/")[1]}>
                            {children}
                        </TransitionSwitch>
                        <LeafletMap />
                    </main>
                    <Modal />
                    <BgTasks />
                    <PopupNotifications />
                    <TooltipFMEContainer />
                    <Footer />
                </div>
            </UnreadItemsProvider>
        </>
    );
}
